// Shared "YYYY-MM-DD" date-key formatting, local (not UTC) time — matches
// the format used throughout the Flights feature (selectedDate, ?date=).
// Kept in one place so Calendar.tsx and the day-marking logic that reads
// its keys can't drift on format.

export function toDateKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function parseDateKey(key: string): Date {
  const [y, m, d] = key.split('-').map(Number);
  return new Date(y, m - 1, d);
}
